export default __webpack_public_path__ + "static/media/save-disabled.58c6c405.svg";